import parsePhoneNumber from 'libphonenumber-js'

const formatPhone = (phone, raw = false) => {
	if(phone && phone.length) {
		let formattedPhone = phone;

		try {
			formattedPhone = raw ? parsePhoneNumber(phone, 'TR').number : parsePhoneNumber(phone, 'TR').formatNational();
		}
		catch(e) {
			console.warn('Format phone warning:', e);
		}

		return formattedPhone;
	}
	else {
		return phone;
	}
}

export default formatPhone